/**
 * Reproduce solo el video del slide activo (y visible en el tamaño de pantalla actual);
 * pausa el resto para ahorrar datos y batería.
 */
(() => {
  if (window.slideshowVideoInit) return;
  window.slideshowVideoInit = true;

  // Los videos esperan a que la pagina termine de cargar: mientras tanto se ve la portada.
  let loaded = document.readyState === 'complete';
  if (!loaded) {
    window.addEventListener('load', () => {
      loaded = true;
      document.querySelectorAll('slide-show[data-sv-init]').forEach((s) => sync(s));
    }, { once: true });
  }

  const isShown = (el) => el.offsetParent !== null || getComputedStyle(el).display !== 'none' && el.getClientRects().length > 0;

  const sync = (slideshow) => {
    const inView = slideshow.dataset.svInView !== 'false';
    slideshow.querySelectorAll('.slideshow__slide').forEach((slide) => {
      const active = slide.classList.contains('is-active');
      slide.querySelectorAll('video[data-slide-video]').forEach((video) => {
        if (active && inView && loaded && isShown(video)) {
          if (video.preload === 'none') video.preload = 'auto';
          video.muted = true;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('slide-show').forEach((slideshow) => {
      if (slideshow.dataset.svInit || !slideshow.querySelector('video[data-slide-video]')) return;
      slideshow.dataset.svInit = 'true';

      // Cambio de slide
      const mo = new MutationObserver(() => sync(slideshow));
      slideshow.querySelectorAll('.slideshow__slide').forEach((slide) => {
        mo.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });

      // Pausar cuando el slideshow sale de pantalla
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            slideshow.dataset.svInView = entry.isIntersecting ? 'true' : 'false';
            sync(slideshow);
          });
        }, { rootMargin: '100px 0px' }).observe(slideshow);
      }

      // Cambio de tamaño (escritorio <-> móvil)
      let t;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(() => sync(slideshow), 200);
      });

      sync(slideshow);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (evt) => init(evt.target));
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('slide-show[data-sv-init]').forEach((s) => sync(s));
  });
})();
